import React from 'react';
import { useLocation } from 'react-router-dom';
import './GlobalFooter.css';

export default function GlobalFooter() {
  const location = useLocation();

  // No mostrar footer en rutas OneBase internas (que ya tienen su propio layout)
  const hideFooter = location.pathname.startsWith('/onebase/') &&
                     !location.pathname.includes('/instagram/') &&
                     !location.pathname.includes('/tiktok/');

  if (hideFooter) return null;

  return null;
}
